export default function getCurrentTimeZoneName() {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return "America/Sao_Paulo";
  }
}
